import { render } from "./ModalExcluirUnicoVeiculo.vue?vue&type=template&id=d0cefeac&scoped=true&ts=true"
import script from "./ModalExcluirUnicoVeiculo.vue?vue&type=script&lang=ts"
export * from "./ModalExcluirUnicoVeiculo.vue?vue&type=script&lang=ts"

import "./ModalExcluirUnicoVeiculo.vue?vue&type=style&index=0&id=d0cefeac&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0cefeac"]])

export default __exports__